<div class="image-upload-modal">
    <Modal
        id="show-image-upload-modal-id"
        {i18n}
        confirmText={i18n.save}
        cancelText={i18n.cancel}
        showCloseButton={true}
        titleText={imageUrl ? i18n.editPlanImage : i18n.planImage}
        bind:enabled={showModal}
        on:modalClosed={close}
        on:confirm={onConfirm}
        on:cancel={onCancel}
    >
        <div slot="body">
            <FormSection>
                <ImageUpload
                    previewType="image"
                    fileRepoSettings={imageUploaderFileRepoSettings}
                    validationSettings={imageUploaderFileValidationSettings}
                    bind:url={imageUrl}
                    i18n={imageUploaderTerms}
                    showImageDescriptionField={showImageDescription}
                    showLabel={false}
                    imageDescriptionMaxLength={imageDescriptionMaxLength}
                    bind:imageDescription={imageDescription}
                    bind:inProgress={imageUploadInProgress}
                    on:fileUploaded={fileIsUploaded}
                    on:fileRemoved={fileIsRemoved} />
            </FormSection>
        </div>
    </Modal>
</div>

<script>
    export let showModal;
    export let planId;
    export let imageUploaderFileRepoSettings;
    export let imageUploaderFileValidationSettings;
    export let imageUrl;
    export let showImageDescription;
    export let imageDescriptionMaxLength;
    export let imageDescription;

    let fileRepoFile = undefined;
    let uploadImageFileRepoId = null;
    let uploadImageSignedFileRepoId = null;
    let uploadImageChanged = false;
    let imageUploadInProgress = false;
    let isFileRemoved = false;
    let imageErrorMessage = undefined;
    let apiUploadSuccess = false;
    const initialImageUrl = imageUrl;

    import { createEventDispatcher } from 'svelte';
    import Modal from "@itslearning/prometheus/assets/modals/Modal/v2/Modal.svelte";
    import ImageUpload from "@itslearning/prometheus/assets/smart-components/ImageUpload/v1/ImageUpload.svelte";
    import FormSection from "@itslearning/prometheus/assets/inputs/Form/v1/FormSection.svelte";
    import i18n from "@its-ui/planner-common/i18n";
    import { deleteImage, setPlanImageUpload } from "@its-ui/planner-common/controllers/updatePlanController";

    const dispatch = createEventDispatcher();

    // don't use label because of Modal title
    $: imageUploaderTerms = ({
        add: i18n.imageUploadTerms.addImage,
        change: i18n.imageUploadTerms.changeImage,
        delete: i18n.imageUploadTerms.removeImage,
        progress: i18n.imageUploadTerms.pictureIsUploading,
        fileSizeExceededDescription: i18n.imageUploadTerms.fileSizeExceededText,
        uploadUserPictureTerms: i18n.imageUploadTerms.userPictureTerms,
        imageDescriptionTitle: i18n.imageUploadTerms.imageDescriptionTitle,
        imageDescriptionHint: i18n.imageUploadTerms.imageDescriptionHint,
    });

    function fileIsUploaded(event) {
        fileRepoFile = event.detail;
        uploadImageFileRepoId = fileRepoFile?.id;
        uploadImageSignedFileRepoId = fileRepoFile?.signedFileRepoId;
        uploadImageChanged = true;
        isFileRemoved = false;
    }

    async function fileIsRemoved() {
        await deleteImage(planId);

        fileRepoFile = null;
        uploadImageFileRepoId = null;
        uploadImageSignedFileRepoId = null;
        uploadImageChanged = true;
        imageUrl = undefined;
        imageDescription = undefined;
        imageErrorMessage = undefined;
        isFileRemoved = true;
    }

    async function onConfirm() {
        if (isFileRemoved) {
            dispachActionDetails(true);

            return;
        }

        const data = await setPlanImageUpload(planId, uploadImageFileRepoId, uploadImageSignedFileRepoId, imageDescription, uploadImageChanged);

        imageErrorMessage = data.errorMessage;
        showModal = false;
        apiUploadSuccess = data.success;
        imageUrl = data.success ? data.imageUrl : initialImageUrl;
        dispachActionDetails(true);
    }

    function dispachActionDetails(isSave) {
        const planImageUpdates = {
            imageUrl: imageUrl,
            imageDescription: imageDescription,
            imageErrorMessage: imageErrorMessage,
            isFileRemoved: isFileRemoved,
            isSave: isSave,
            apiUploadSuccess: apiUploadSuccess
        };

        dispatch('saveCancelAction', { planImageUpdates });
    }

    async function onCancel() {
        showModal = false;
        imageErrorMessage = undefined;
        dispachActionDetails(false);
    }

</script>